/* eslint-disable no-console */
import React, {useEffect, useState} from 'react';

import Loader from '../../../../../components/Loader/Loader';
import {API_ENDPOINT_JSON} from '../../../../../config';
import {APITypeEnum} from '../../../../../services/interface/tableAPIType';
import nzmAPI from '../../../../../services/modules/NZM/NZMAPI';
import LabelAndCharts from '../../../generalized/utils/LabelAndCharts';
import FinancialElecWater from '../electricity/utils/FinancialElec';

import ConsumptionWater from './utils/ConsumptionWater';
import OperationalWater from './utils/OperationalWater';

const WaterTab: React.FC<{
  selCountry: number | undefined;
  selState: number | undefined;
  selectedYear: string;
  setTabLoading: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({selCountry, selState, selectedYear, setTabLoading}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState<any[]>([]);

  useEffect(() => {
    const filterCountry = selCountry ?? '';
    const filterState = selState ?? '';
    const filterAll = `/${
      filterCountry
        ? filterState
          ? `${filterCountry}/${filterState}`
          : `${filterCountry}`
        : ''
    }`;

    setIsLoading(true);
    setTabLoading(true);
    if (selectedYear) {
      Promise.all([
        nzmAPI(
          APITypeEnum.GET_ALL,
          API_ENDPOINT_JSON.NZM.utility.water,
          `${selectedYear}${filterAll}`
        )
      ])
        .then(([res1]) => {
          setData(res1);
        })
        .catch(() => {})
        .finally(() => {
          setIsLoading(false);
          setTabLoading(false);
        });
    }
  }, [selectedYear, selCountry, selState]);

  return isLoading ? (
    <Loader topMargin />
  ) : (
    <>
      <LabelAndCharts title="Consumption">
        <ConsumptionWater data={data} />
      </LabelAndCharts>
      <LabelAndCharts title="Operational">
        <OperationalWater data={data} />
      </LabelAndCharts>
      <LabelAndCharts title="Financial">
        <FinancialElecWater data={data} type="water" />
      </LabelAndCharts>
    </>
  );
};

export default WaterTab;
